// extracted by mini-css-extract-plugin
export default {"rating":"iK-z","numberOfStars":"jK-z","count":"kK-z","barGraphSpacing":"lK-z","barGraph":"mK-z"};